import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

interface RelatedQuestionsState {
  relatedQuestionsVisibleMap: Record<string, boolean>;
}

const initialState: RelatedQuestionsState = {
  relatedQuestionsVisibleMap: {},
};

export const relatedQuestionsSlice = createSlice({
  name: 'relatedQuestions',
  initialState,
  reducers: {
    toggleRelatesQuestionsVisible: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const currentlyVisible = state.relatedQuestionsVisibleMap[id];
      if (currentlyVisible) {
        delete state.relatedQuestionsVisibleMap[id];
      } else {
        state.relatedQuestionsVisibleMap[id] = true;
      }
    },
  },
});

export const relatedQuestionsState = (state: RootState) =>
  state.relatedQuestions as RelatedQuestionsState;

export const { toggleRelatesQuestionsVisible } = relatedQuestionsSlice.actions;

export default relatedQuestionsSlice.reducer;
